import Joi from 'joi';

export default Joi.object({
	ordinal: Joi.number()
		.integer()
		.min(1)
		.max(3),
	parents: Joi.number()
		.integer()
		.min(1)
		.max(2),
	child6: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Počet dětí musí být celé kladné číslo nebo 0.',
		})),
	child15: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Počet dětí musí být celé kladné číslo nebo 0.',
		})),
	child26: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Počet dětí musí být celé kladné číslo nebo 0.',
		})),
	income: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Průměrný měsíční příjem musí být celé kladné číslo nebo 0.',
		})),
});
